// extracted by mini-css-extract-plugin
export default {"title":"title-k4gie","text":"text-R06Fp"};